module.exports = __webpack_public_path__ + "media/src/images/icons/icons8-city-46614588268fdfab5ccd743a6c1d4211.png";